import { render, staticRenderFns } from "./ShowFinalJournalContent.vue?vue&type=template&id=3045490f&scoped=true"
import script from "./ShowFinalJournalContent.vue?vue&type=script&lang=js"
export * from "./ShowFinalJournalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045490f",
  null
  
)

export default component.exports